import $ from 'jquery';
import _ from 'underscore';
import Cookie from '@component/common/src/util/Cookie';
import PageApp from 'pageApp';
import {
  Actions,
  AddToList,
  Cookies,
  ApplicationMessages,
  Timeouts,
} from '../util/Constants';
import AddToListModel from './AddToListModel';
import Properties from '../util/Properties';

export default class AddToListController {
  constructor(options) {
    Object.assign(this, options);
    this.isGuestUser = true;
  }

  fireAddToListCall() {
    const addToListModel = new AddToListModel({}, {
      productModel: this.productModel,
      source: this.source,
    });
    if (AddToListController.checkUserStatus()) {
      this.isGuestUser = false;
      this.getUserLists(addToListModel);
    } else {
      this.toggleLoading(true);
      this.saveToDefaultList(addToListModel);
    }
  }

  saveToDefaultList(model) {
    model.save(model.toJSON(), {
      success: this.handleSuccess.bind(this),
      error: this.handleError.bind(this),
      timeout: Timeouts.async,
    });
  }

  toggleLoading(toggle) {
    const { showLoader, hideLoader } = Actions.product.ctaButton;
    const action = toggle ? showLoader : hideLoader;
    const eventName = `${action}:${this.eventId}`;

    PageApp.channel.trigger(eventName, this.$currentTarget);
  }

  static fireLinkTag(data) {
    PageApp.channel.trigger(Actions.tealium.linkTag, data);
  }

  handleSuccess(model, response, options) {
    let listItem;
    let item;

    this.toggleLoading(false);

    if (_.isEmpty(response)) {
      this.handleError(model, response, options);
      return;
    }

    AddToListController.setCookies(response);
    if (Array.isArray(response.CustomerList.list) && response.CustomerList.list.length > 0) {
      [listItem] = response.CustomerList.list;
      item = listItem.items[listItem.items.length - 1];
      // 18A wishlist-xapi: meta information is missing, it's got implemented in 18B
      if (response.CustomerList.meta) {
        const { data } = response.CustomerList.meta.analytics;
        data.pdp_outfitting = [$('#pdp-overlay-modal-id').hasClass('visible').toString()];
        AddToListController.fireLinkTag(data);
      }

      // Triggering Pros Event with product Id
      AddToListController.triggerEnableHeartProsEvent(item);
      const message = `Added to <a href="${AddToList.addToListPageUrl}?listGuid=${listItem.listGuid}">${listItem.name}</a>.`;
      PageApp.channel.trigger(`${Actions.product.ctaNotification.success}:${this.eventId}`, message);
    }
  }

  static setCookies(response) {
    const expires = new Date(new Date().getTime() + Cookies.thirthyDaysInMS);
    AddToListController.setCookie(Cookies.userGuid, response.CustomerList.user.guid, expires);
    AddToListController.setCookie(Cookies.userId, response.CustomerList.user.id, expires);
  }

  // todo: move this code to their one static class, violate DRY principle
  static setCookie(cookieName, cookieValue, expires) {
    Cookie.set(cookieName, cookieValue, undefined, {
      expires,
    });
  }

  handleError(model, response, options) {
    this.toggleLoading(false);

    const message = options.errorMessage || ApplicationMessages.technicalIssue;

    PageApp.channel.trigger(`${Actions.product.ctaNotification.error}:${this.eventId}`, message);
  }

  getUserLists(addToListModel) {
    const listsUrl = '/xapi/wishlist/v1/lists?default=false&';
    const userGuid = Cookie.get(Cookies.userGuid);
    $.ajax({
      url: `${listsUrl}userGuid=${userGuid}`,
    }).done((lists) => {
      if (lists.CustomerList && lists.CustomerList.list.length > 1) {
        PageApp.channel.trigger(Actions.product.list.success, {
          listData: lists,
          productModel: this.productModel,
          productState: this.getProductState(),
        });
      } else {
        this.saveToDefaultList(addToListModel);
      }
    }).fail((xhr) => {
      const errorObj = JSON.parse(xhr.responseText);
      if (errorObj && errorObj.errors) {
        PageApp.channel.trigger(`${Actions.product.ctaNotification.error}:${this.eventId}`, errorObj.errors.error[0].message);
      } else {
        PageApp.channel.trigger(`${Actions.product.ctaNotification.error}:${this.eventId}`, ApplicationMessages.technicalIssue);
      }
    });
  }

  getProductState() {
    const viewState = this.productModel.get('viewState');
    const productState = {
      selectedImage: viewState.imagery.images[0].filePath,
      selectedUpc: viewState.detail.selectedUpc,
      price: viewState.detail.selectedPrice,
      selectedQuantity: viewState.detail.selectedQuantity,
      selectedColor: this.getSelectedColor(viewState),
      selectedSize: AddToListController.getSelectedSize(viewState),
      selectedType: AddToListController.getSelectedType(viewState),
      breadCrumbCategories: viewState.detail.breadCrumbCategories,
      elementCategory: 'PDP WISHLIST',
    };

    return productState;
  }

  getSelectedColor(viewState) {
    const product = this.productModel.get('product');
    let selectedColor;
    const colorTraits = viewState.traits.color;
    if (colorTraits) {
      const swatchTierIndex = Number(colorTraits.selectedTierIndex) || 0;
      const selectedSwatchIndex = Number(colorTraits.selectedSwatchIndex) || 0;
      selectedColor = product.traits.colors.colorMap[colorTraits.swatchTiers[swatchTierIndex].swatches[selectedSwatchIndex].id].name;
    }
    return selectedColor;
  }

  static getSelectedSize(viewState) {
    const sizeTraits = viewState.traits.size;
    let selectedSize;
    if (sizeTraits) {
      const swatchTierIndex = Number(sizeTraits.selectedTierIndex || 0);
      const selectedSwatchIndex = Number(sizeTraits.selectedSwatchIndex || 0);
      selectedSize = sizeTraits.swatchTiers[swatchTierIndex].swatches[selectedSwatchIndex].displayName;
    }
    return selectedSize;
  }

  static getSelectedType(viewState) {
    const typeTraits = viewState.traits.type;
    let selectedType;
    if (typeTraits) {
      const swatchTierIndex = Number(typeTraits.selectedTierIndex || 0);
      const selectedSwatchIndex = Number(typeTraits.selectedSwatchIndex || 0);
      selectedType = typeTraits.swatchTiers[swatchTierIndex].swatches[selectedSwatchIndex].displayName;
    }
    return selectedType;
  }

  static checkUserStatus() {
    return Cookie.get(Cookies.userGuid) && Cookie.get(Cookies.signedIn) === '1';
  }

  static getPrice(selectedPrice) {
    let price = '';
    const tieredPrice = selectedPrice && selectedPrice.price && selectedPrice.price.tieredPrice;
    if (tieredPrice) {
      price = tieredPrice[tieredPrice.length - 1].values[0].value;
    }
    return price;
  }

  static triggerEnableHeartProsEvent(item) {
    const addToListProsKS = Properties.get('prosZonesAddToListEnabled');
    // Adding Null checks to avoid NPEs
    if (addToListProsKS && item && item.upc && item.upc.product && item.upc.product.id) {
      PageApp.channel.trigger('feature::pros-factory::enableHeart', item.upc.product.id);
    }
  }
}




// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/add-to-list/AddToListController.js